import { ReactComponent as CrownSvg } from '../../../../../../../assets/svg/crown.svg';
import { ReactComponent as ThumbsUpLineSvg } from '../../../../../../../assets/svg/thumbs-up-line.svg';
import BottomDialog from '../../../../../../../components/bottomDialog';
import Tag from '../../../../../../../components/tag';
import About from './about';
import Result from './result';
import Routine from './routine';

const Info = ({ dialogRef, closeBottomDialog, challenge }) => {
  return (
    <dialog
      ref={dialogRef}
      className='w-full h-full max-w-lg max-h-full bg-transparent'
    >
      {challenge && (
        <div className='bg-secondary fixed bottom-0 w-full max-w-lg rounded-t-3xl p-4 h-[95%] flex flex-col text-white overflow-y-hidden'>
          <div className='overflow-y-auto scrollbar-hidden rounded-xl'>
            <div className='relative'>
              <img
                src={challenge.bannerUrl}
                alt='challenge poster'
                className='w-full rounded-xl'
              />
              <button
                className='text-2xl absolute top-2 right-2 size-6 bg-tertiary/70 rounded-full flex items-center justify-center'
                onClick={closeBottomDialog}
              >
                🅧
              </button>
              {challenge.premium && (
                <div className='absolute top-0 left-0 bg-accent px-3 py-1 rounded-tl-xl rounded-br-xl'>
                  <CrownSvg className='size-5' />
                </div>
              )}
            </div>
            <h1 className='text-center mt-4 text-sm'>{challenge.title}</h1>
            <p className='mt-4 mb-6 uppercase whitespace-pre-line text-sm'>
              {challenge.description}
            </p>
            <div
              className='flex justify-start items-end gap-12 mt-4 px-4 text-sm mb-6'
              style={{ fontFamily: "'Teko', sans-serif" }}
            >
              <button className='flex flex-col justify-center items-center'>
                <span className=''>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    viewBox='0 0 24 24'
                    fill='currentColor'
                    className='size-6'
                  >
                    <path
                      fillRule='evenodd'
                      d='M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z'
                      clipRule='evenodd'
                    />
                  </svg>
                </span>
                <span className='text-lg'>My List</span>
              </button>
              <button className='flex flex-col justify-center items-center'>
                <span className=''>
                  <ThumbsUpLineSvg
                    className='size-5'
                    stroke='white'
                  />
                </span>
                <span className='text-lg'>Rated</span>
              </button>
              <button className='flex flex-col justify-center items-center'>
                <span>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    strokeWidth='1.5'
                    stroke='currentColor'
                    className='size-6'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      d='M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15m0-3-3-3m0 0-3 3m3-3V15'
                    />
                  </svg>
                </span>
                <span className='text-lg'>Share</span>
              </button>
            </div>
            <div className='space-y-4'>
              <About challenge={challenge} />
              <Result challenge={challenge} />
              <Routine challenge={challenge} />
            </div>
          </div>
        </div>
      )}
    </dialog>
  );
};

export default Info;
